import type { MockDatabase } from "@/types/domain";
import type { MockRequest, MockResponse } from "@/mocks/router";
import { extras, store } from "@/mocks/store";
import { err, matchPath, nowStamp, ok, paginate } from "./_utils";

export function handleAdmin(req: MockRequest): MockResponse | null {
  const method = req.method.toUpperCase();
  const path = req.path.replace(/\/+$/, "") || "/";
  const { query, body } = req;

  if (method === "GET" && path === "/api/admin/channels") return ok({ data: store.CHANNELS });
  {
    const m = matchPath("/api/admin/channels/:code", path);
    if (m && method === "GET") {
      const ch = store.CHANNELS.find((c) => c.code === m.code);
      if (!ch) return err(404, "NOT_FOUND", "渠道不存在");
      return ok({ data: ch });
    }
    if (m && method === "PATCH") {
      const idx = store.CHANNELS.findIndex((c) => c.code === m.code);
      if (idx < 0) return err(404, "NOT_FOUND", "渠道不存在");
      store.CHANNELS[idx] = { ...store.CHANNELS[idx], ...(body as object) };
      return ok({ data: store.CHANNELS[idx] });
    }
  }

  if (method === "GET" && path === "/api/admin/users") return ok(paginate(store.USERS, query));
  if (method === "POST" && path === "/api/admin/users") {
    const payload = body as Partial<MockDatabase["USERS"][number]>;
    const user = {
      id: payload.id || `u_${Date.now().toString(36)}`,
      name: payload.name || "新用户",
      email: payload.email || "",
      role: payload.role || "operator",
      games: payload.games || [],
      lastActive: "刚刚",
      status: payload.status || "active",
    };
    store.USERS.push(user);
    return ok({ data: user }, 201);
  }
  {
    const m = matchPath("/api/admin/users/:id", path);
    if (m && method === "PATCH") {
      const idx = store.USERS.findIndex((u) => u.id === m.id);
      if (idx < 0) return err(404, "NOT_FOUND", "用户不存在");
      store.USERS[idx] = { ...store.USERS[idx], ...(body as object) };
      return ok({ data: store.USERS[idx] });
    }
  }
  if (method === "GET" && path === "/api/admin/audit-logs") return ok(paginate(store.AUDIT_LOGS, query));
  if (method === "POST" && path === "/api/admin/audit-logs") {
    const payload = body as Partial<MockDatabase["AUDIT_LOGS"][number]>;
    const log = {
      time: payload.time || nowStamp(),
      user: payload.user || store.ROLES[store.SESSION.currentRole]?.user || "system",
      action: payload.action || "操作",
      target: payload.target || "",
      detail: payload.detail || "",
    };
    store.AUDIT_LOGS.unshift(log);
    return ok({ data: log }, 201);
  }

  if (method === "GET" && path === "/api/admin/platform/health") return ok({ data: store.GLOBAL_STATS });
  if (method === "GET" && path === "/api/admin/platform/stats") return ok({ data: store.GLOBAL_STATS });
  if (method === "GET" && path === "/api/admin/settings/system") return ok({ data: extras.systemSettings });
  if (method === "PATCH" && path === "/api/admin/settings/system") {
    extras.systemSettings = { ...extras.systemSettings, ...(body as object) } as typeof extras.systemSettings;
    return ok({ data: extras.systemSettings });
  }
  if (method === "GET" && path === "/api/admin/credentials") {
    const data = store.GAMES.map((g) => ({ gameId: g.id, gameName: g.name, hasSecret: !!extras.secrets[g.id] }));
    return ok({ data, meta: { total: data.length, page: 1, pageSize: 100 } });
  }
  if (method === "GET" && path === "/api/admin/config-schemas") {
    return ok({ data: extras.configSchemas, meta: { total: extras.configSchemas.length, page: 1, pageSize: 50 } });
  }

  return null;
}
